import * as guards from '../../../common/routeGuards';
import * as R from '../routesList';

const genericGuards = [guards.forbidAuth];

export default {
  [R.LOGIN]: [...genericGuards],
  [R.PASSWORD_RECOVERY]: [...genericGuards],
};
